// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://api.liontech.eu:9091',
  googleMapsApiKey: 'AIzaSyBcvHYUlLg8ZxcHQEXjCKC6zt3ftuHHtNY',
  earthquakeSocketUrl: 'wss://api.liontech.eu:9091/eq-external-api/seizmic',
  chatSocketUrl: 'wss://api.liontech.eu:9091/eq-chat-api/chat',
  version: 1.001
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
